import { CustomTravelLocation, CustomTravelSchedule } from '@/atoms/customTravelFormState';
import dayjs from 'dayjs';
import minBy from 'lodash/minBy';
import { CustomRecommend, RecommendType } from '@/types/apollo';

const isEqualArrays = (a: string[], b: string[]) =>
  a.length === b.length && a.every((element, index) => element === b[index]);

export const getFilteredRecommendsByDestinations = (
  customRecommends: CustomRecommend[] | null | undefined,
  destinations: CustomTravelLocation[] | undefined,
) => {
  return customRecommends?.filter((o) =>
    destinations?.some((destination) => isEqualArrays(o.cityCodes, destination?.codes || [])),
  );
};

export const getFilterRecommendsBySchedule = (
  customRecommends: CustomRecommend[] | null | undefined,
  tourSchedule: CustomTravelSchedule | undefined,
) => {
  const targetMonth = tourSchedule?.schedules?.[0].from ? dayjs(tourSchedule?.schedules?.[0].from).month() + 1 : -1;
  return customRecommends?.map((o) => ({
    ...o,
    recommends: o.recommends?.filter((o) => o.month === targetMonth),
  }));
};

export const getFilterRecommendsByOrder = (customRecommends: CustomRecommend[] | null | undefined) => {
  return customRecommends?.map((o) => {
    const minOrderRecommends = minBy(o.recommends, 'order');
    return {
      ...o,
      recommends: minOrderRecommends ? [minOrderRecommends] : [],
    };
  });
};

export const getTargetRecommends = (customRecommends: CustomRecommend[] | null | undefined) =>
  customRecommends?.reduce(
    (
      acc: (RecommendType & {
        name: string;
      })[],
      cur: CustomRecommend,
    ) => [...acc, ...(cur.recommends?.map((o) => ({ ...o, name: cur.name })) || [])],
    [],
  ) || [];
